import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { DiagnosisCodesQuery, DiagnosisCodesQueryVariables } from '@/shared/api';
import DIAGNOSIS_CODES_QUERY from '../queries/diagnosisCodes';

/**
 * Loads a page of diagnosis codes matching the search filter. Runs DIAGNOSIS_CODES_QUERY and throws the first GraphQL error message when diagnosisCodes is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @returns The diagnosis codes page.
 */
const fetchDiagnosisCodes = async (
  filter: DiagnosisCodesQueryVariables['filter'],
  limit = 10,
): Promise<DiagnosisCodesQuery['diagnosisCodes']> => {
  const client = createClient();
  const result = await client.query<DiagnosisCodesQuery, DiagnosisCodesQueryVariables>({
    query: DIAGNOSIS_CODES_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = result;
  const { diagnosisCodes } = data;
  if (_.isNil(diagnosisCodes) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return diagnosisCodes;
};

export default fetchDiagnosisCodes;
